module.exports = __webpack_public_path__ + "images/Icon_Invest_1.png?dcc8776";


//////////////////
// WEBPACK FOOTER
// ./assets/component/index/images/icons/Icon_Invest_1.png
// module id = 341
// module chunks = 0